<script setup lang="ts">
import { useRoute } from 'vue-router'
import routers from '~/common/routers/routerList'
import { useAppConfigStore } from '~/stores/useAppConfig'

const { city = 0 } = useCityInfoStore()
const route = useRoute()
// TDK所需参数
const paramsRef = computed(() => {
  return {
    cityId: city,
    floorId: route?.params?.floorId ?? '',
    floorNewsTab: route?.params?.floorNewsTab ?? '', // 楼盘动态标签参数 0：全部
    houseModelId: route?.params?.houseModelId ?? '', // 户型ID
    rankingTypeId: route?.params?.rankingTypeId ?? '', // 榜单类型ID
    themeId: route?.params?.themeId ?? '', // 主题找房-主题ID入参
    p: route.params?.filterIndex ?? route.params.condition ? combinationCondition(route.params?.filterIndex ?? route.params.condition) : '',
  }
})
// 获取TDK数据
const { tdkData, refresh } = await useMeta(paramsRef)

// 设置页面TDK参数
function setTDK() {
  const routeTemp = routers.find(i => i.name === route.name)
  const pcPath = typeof routeTemp?.pcPath === 'function' ? routeTemp.pcPath(route?.params) : ''
  useHead({
    title: tdkData.value?.title ?? '房产超市',
    meta: [
      { name: 'keywords', content: tdkData.value?.keywords ?? '' },
      { name: 'description', content: tdkData.value?.description ?? '' },
    ],
    link: [
      { rel: 'canonical', href: pcPath },
    ],
  })
}

setTDK()
const { getPlatform } = useAppConfigStore()
// 公共底部是否显示
const footerShow = computed(() => {
  let show = true
  if (getPlatform !== '') {
    show = false
  }
  else {
    show = route?.meta?.footerShow as boolean ?? true
  }
  return show
})
// 监听路由切换
watch(() => route.fullPath, async () => {
  await refresh()
  setTDK()
})
</script>

<template>
  <NuxtPage :tdk-data="tdkData" />
  <Footer :tdk-data="tdkData" :show="footerShow" />
</template>

<style scoped lang="scss">

</style>
